// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════════
   analytics.css  —  Professional Analytics Dashboard
   Place at:  src/components/analytics/analytics.css
   ═══════════════════════════════════════════════════════════════════

   Design tokens
   ─────────────
   Primary:   #4F46E5  (indigo)
   Surface:   #FFFFFF
   BG:        #F8F9FC
   Border:    #E8EAF0
   Text-1:    #0F172A  (headings)
   Text-2:    #475569  (body)
   Text-3:    #94A3B8  (muted)
   Green:     #10B981
   Red:       #EF4444
   Amber:     #F59E0B
   ═══════════════════════════════════════════════════════════════════ */

/* ── Google Font import (DM Sans) ──────────────────────────────── */

/* ── Animations ────────────────────────────────────────────────── */
@keyframes fadeSlideUp {
    from {
        opacity: 0;
        transform: translateY(8px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes skeletonPulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.4;
    }
}

/* ════════════════════════════════════════════════════════════════
   ROOT
   ════════════════════════════════════════════════════════════════ */
.analytics-root {
    padding: 28px 32px;
    background: #F8F9FC;
    min-height: 100vh;
    font-family: "DM Sans", "Inter", -apple-system, sans-serif;
    color: #0F172A;
    -webkit-font-smoothing: antialiased;
}

/* ════════════════════════════════════════════════════════════════
   HEADER
   ════════════════════════════════════════════════════════════════ */
.analytics-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    flex-wrap: wrap;
    gap: 16px;
}

.analytics-header-left {
    display: flex;
    align-items: center;
    gap: 14px;
}

.analytics-user-avatar {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 700;
    flex-shrink: 0;
    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
}

.analytics-title {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    color: #0F172A;
    letter-spacing: -0.3px;
}

.analytics-subtitle {
    margin: 3px 0 0;
    font-size: 13px;
    color: #94A3B8;
    font-weight: 400;
}

.analytics-header-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.analytics-refresh-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border-radius: 8px;
    border: 1.5px solid #E8EAF0;
    background: #fff;
    color: #475569;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s;
    font-family: inherit;
}

.analytics-refresh-btn:hover {
    background: #F8F9FC;
    border-color: #CBD5E1;
    color: #0F172A;
}

/* ════════════════════════════════════════════════════════════════
   PERIOD BAR  (Today / This Week / This Month / This Year / Custom)
   ════════════════════════════════════════════════════════════════ */
.analytics-period-bar {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 8px;
    flex-wrap: wrap;
    background: #fff;
    border: 1.5px solid #E8EAF0;
    padding: 4px;
    border-radius: 12px;
    width: fit-content;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.analytics-period-btn {
    padding: 8px 16px;
    border-radius: 8px;
    border: none;
    background: transparent;
    color: #64748B;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s;
    white-space: nowrap;
    font-family: inherit;
    line-height: 1;
}

.analytics-period-btn:hover {
    background: #F1F5F9;
    color: #0F172A;
}

.analytics-period-btn.active {
    background: #4F46E5;
    color: #fff;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(79, 70, 229, 0.25);
}

/* ── Period btn group (button + picker chevron together) ───────── */
.period-btn-group {
    display: flex;
    align-items: center;
    gap: 1px;
    position: relative;
}

/* ── Week / Month picker ───────────────────────────────────────── */
.period-picker {
    position: relative;
    display: inline-block;
}

.period-picker-btn {
    display: flex;
    align-items: center;
    gap: 3px;
    padding: 8px 7px;
    border-radius: 7px;
    border: none;
    background: transparent;
    color: #94A3B8;
    font-size: 10px;
    cursor: pointer;
    transition: all 0.15s;
    font-family: inherit;
}

.period-picker-btn:hover {
    background: #F1F5F9;
    color: #475569;
}

.period-picker-caret {
    font-size: 7px;
}

/* Dropdown */
.period-picker-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    background: #fff;
    border: 1.5px solid #E8EAF0;
    border-radius: 14px;
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.06);
    min-width: 220px;
    z-index: 1000;
    overflow: hidden;
    animation: fadeSlideUp 0.15s ease both;
    padding: 6px;
}

.period-picker-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 10px 14px;
    border: none;
    background: transparent;
    color: #374151;
    font-size: 13px;
    text-align: left;
    cursor: pointer;
    border-radius: 9px;
    transition: background 0.1s;
    font-family: inherit;
}

.period-picker-option:hover {
    background: #F8F9FC;
}

.period-picker-option.selected {
    background: #EEF2FF;
    color: #4F46E5;
    font-weight: 600;
}

.period-picker-option.selected::after {
    content: "✓";
    font-size: 12px;
    color: #4F46E5;
}

.period-picker-sub {
    font-size: 11px;
    color: #94A3B8;
    font-weight: 400;
    margin-left: 6px;
}

/* ── Custom range active label ─────────────────────────────────── */
.analytics-custom-active-label {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 6px 12px;
    border-radius: 8px;
    background: #EEF2FF;
    border: 1.5px solid #C7D2FE;
    color: #4F46E5;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
}

/* ── Custom date range picker inputs ───────────────────────────── */
.analytics-custom-range {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    flex-wrap: wrap;
    background: #fff;
    border: 1.5px solid #E8EAF0;
    border-radius: 12px;
    padding: 12px 18px;
    width: fit-content;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
    animation: fadeSlideUp 0.2s ease both;
}

.analytics-custom-label {
    font-size: 12px;
    color: #94A3B8;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.analytics-date-input {
    border: 1.5px solid #E8EAF0;
    border-radius: 8px;
    padding: 7px 12px;
    font-size: 13px;
    color: #0F172A;
    background: #F8F9FC;
    outline: none;
    cursor: pointer;
    font-family: inherit;
    font-weight: 500;
    transition: border-color 0.15s, box-shadow 0.15s;
}

.analytics-date-input:focus {
    border-color: #4F46E5;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
    background: #fff;
}

/* ── Period context chips ──────────────────────────────────────── */
.analytics-period-context {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 10px;
    margin-bottom: 24px;
}

.period-context-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
}

.period-context-current {
    background: #F0FDF4;
    border: 1px solid #BBF7D0;
    color: #166534;
}

.period-context-current strong {
    color: #15803D;
    font-weight: 700;
}

.period-context-prev {
    background: #F5F3FF;
    border: 1px solid #DDD6FE;
    color: #5B21B6;
}

.period-context-prev strong {
    color: #7C3AED;
    font-weight: 700;
}

/* ════════════════════════════════════════════════════════════════
   ERROR BANNER
   ════════════════════════════════════════════════════════════════ */
.analytics-error-banner {
    background: #FFF1F2;
    border: 1.5px solid #FECDD3;
    border-radius: 10px;
    padding: 14px 18px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    color: #BE123C;
}

.analytics-error-banner button {
    font-size: 13px;
    color: #4F46E5;
    background: none;
    border: none;
    cursor: pointer;
    font-weight: 600;
    font-family: inherit;
}

/* ════════════════════════════════════════════════════════════════
   EMPTY STATE
   ════════════════════════════════════════════════════════════════ */
.analytics-empty {
    text-align: center;
    padding: 80px 24px;
}

.analytics-empty-icon {
    font-size: 48px;
    margin-bottom: 20px;
    opacity: 0.6;
}

.analytics-empty-title {
    font-size: 17px;
    font-weight: 700;
    color: #0F172A;
    margin-bottom: 8px;
}

.analytics-empty-sub {
    font-size: 13px;
    color: #94A3B8;
}

/* ════════════════════════════════════════════════════════════════
   SKELETON LOADER
   ════════════════════════════════════════════════════════════════ */
.analytics-skeleton-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
}

.analytics-skeleton-card {
    background: #fff;
    border: 1.5px solid #E8EAF0;
    border-radius: 14px;
    padding: 20px;
    animation: skeletonPulse 1.6s ease-in-out infinite;
}

.analytics-skeleton-line {
    background: #F1F5F9;
    border-radius: 6px;
    display: block;
}

/* ════════════════════════════════════════════════════════════════
   SECTION TITLE
   ════════════════════════════════════════════════════════════════ */
.sc-section-title {
    font-size: 11px;
    font-weight: 700;
    color: #94A3B8;
    margin: 0 0 16px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

/* ════════════════════════════════════════════════════════════════
   SUMMARY CARDS
   ════════════════════════════════════════════════════════════════ */
.sc-section {
    margin-bottom: 32px;
    animation: fadeSlideUp 0.3s ease both;
}

.sc-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));
    gap: 14px;
}

.sc-card {
    background: #fff;
    border: 1.5px solid #E8EAF0;
    border-radius: 14px;
    padding: 18px 20px;
    transition: box-shadow 0.2s, transform 0.2s, border-color 0.2s;
    cursor: default;
    position: relative;
    overflow: hidden;
}

.sc-card::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #4F46E5, #7C3AED);
    opacity: 0;
    transition: opacity 0.2s;
}

.sc-card:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
    border-color: #C7D2FE;
}

.sc-card:hover::before {
    opacity: 1;
}

.sc-card-top {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 14px;
}

.sc-icon {
    font-size: 18px;
    line-height: 1;
}

.sc-label {
    font-size: 12px;
    font-weight: 600;
    color: #64748B;
    line-height: 1.3;
    letter-spacing: 0.01em;
}

.sc-value {
    font-size: 26px;
    font-weight: 700;
    color: #0F172A;
    line-height: 1;
    margin-bottom: 8px;
    letter-spacing: -0.5px;
}

.sc-change {
    font-size: 11px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 3px;
    flex-wrap: wrap;
}

.sc-change.pos {
    color: #10B981;
}

.sc-change.neg {
    color: #EF4444;
}

.sc-change.neutral {
    color: #94A3B8;
    font-weight: 500;
}

.sc-change-bracket {
    font-size: 10px;
    font-weight: 400;
    opacity: 0.7;
    margin-left: 2px;
}

/* ════════════════════════════════════════════════════════════════
   CHARTS SECTION
   ════════════════════════════════════════════════════════════════ */
.charts-section {
    margin-bottom: 32px;
    animation: fadeSlideUp 0.35s ease 0.05s both;
}

.charts-row {
    display: grid;
    grid-template-columns: 3fr 2fr;
    gap: 16px;
    margin-bottom: 16px;
}

@media (max-width: 767.98px) {
    .charts-row {
        grid-template-columns: 1fr;
    }
}

/* Chart card */
.chart-card {
    background: #fff;
    border: 1.5px solid #E8EAF0;
    border-radius: 14px;
    padding: 20px 22px;
    position: relative;
    transition: box-shadow 0.2s;
}

.chart-card:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.chart-card-wide {
    width: 100%;
    box-sizing: border-box;
}

.chart-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
    flex-wrap: wrap;
    gap: 8px;
}

.chart-card-title {
    font-size: 14px;
    font-weight: 700;
    color: #0F172A;
    letter-spacing: -0.1px;
}

.chart-card-sub {
    font-size: 12px;
    color: #94A3B8;
    font-weight: 400;
}

/* Chart legend */
.chart-legend {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
}

.chart-legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #64748B;
    font-weight: 500;
}

.chart-legend-dot {
    width: 8px;
    height: 8px;
    border-radius: 2px;
    flex-shrink: 0;
}

/* Empty chart */
.chart-empty {
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #CBD5E1;
    font-size: 13px;
    font-weight: 500;
}

/* Donut center */
.donut-center-label {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -28%);
    text-align: center;
    pointer-events: none;
}

.donut-center-value {
    font-size: 24px;
    font-weight: 700;
    color: #0F172A;
    line-height: 1;
    letter-spacing: -0.5px;
}

.donut-center-sub {
    font-size: 11px;
    color: #94A3B8;
    margin-top: 3px;
    font-weight: 500;
}

/* Donut legend rows */
.donut-legend {
    margin-top: 18px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.donut-legend-row {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
}

.donut-legend-dot {
    width: 10px;
    height: 10px;
    border-radius: 3px;
    flex-shrink: 0;
}

.donut-legend-label {
    flex: 1 1;
    color: #475569;
    font-weight: 500;
}

.donut-legend-count {
    font-weight: 700;
    color: #0F172A;
    min-width: 28px;
    text-align: right;
}

.donut-legend-pct {
    color: #94A3B8;
    font-size: 12px;
    min-width: 40px;
    text-align: right;
}

/* ════════════════════════════════════════════════════════════════
   DETAIL TABS BAR
   ════════════════════════════════════════════════════════════════ */
.analytics-tabs-bar {
    display: flex;
    gap: 4px;
    margin-bottom: 20px;
    background: #fff;
    border: 1.5px solid #E8EAF0;
    border-radius: 12px;
    padding: 4px;
    width: fit-content;
    flex-wrap: wrap;
    animation: fadeSlideUp 0.35s ease 0.1s both;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.analytics-tab-btn {
    padding: 9px 20px;
    border-radius: 9px;
    border: none;
    background: transparent;
    color: #64748B;
    font-weight: 500;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.15s;
    font-family: inherit;
    white-space: nowrap;
}

.analytics-tab-btn:hover {
    background: #F8F9FC;
    color: #0F172A;
}

.analytics-tab-btn.active {
    background: #4F46E5;
    color: #fff;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(79, 70, 229, 0.25);
}

.analytics-tab-content {
    animation: fadeSlideUp 0.25s ease both;
}

/* ════════════════════════════════════════════════════════════════
   EXPORT BUTTON
   ════════════════════════════════════════════════════════════════ */
.export-wrapper {
    position: relative;
    display: inline-block;
}

.export-main-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border-radius: 8px;
    border: 1.5px solid #E8EAF0;
    background: #fff;
    color: #475569;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s;
    white-space: nowrap;
    font-family: inherit;
}

.export-main-btn:hover {
    background: #F8F9FC;
    border-color: #CBD5E1;
    color: #0F172A;
}

.export-icon {
    font-size: 13px;
}

.export-caret {
    font-size: 8px;
    color: #94A3B8;
}

.export-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background: #fff;
    border: 1.5px solid #E8EAF0;
    border-radius: 14px;
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.06);
    min-width: 220px;
    z-index: 999;
    overflow: hidden;
    animation: fadeSlideUp 0.15s ease both;
    padding: 6px;
}

.export-option {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 11px 14px;
    border: none;
    background: transparent;
    cursor: pointer;
    text-align: left;
    transition: background 0.12s;
    border-radius: 9px;
    font-family: inherit;
}

.export-option:hover {
    background: #F8F9FC;
}

.export-option-icon {
    font-size: 20px;
    flex-shrink: 0;
}

.export-option-label {
    font-size: 13px;
    font-weight: 600;
    color: #0F172A;
}

.export-option-sub {
    font-size: 11px;
    color: #94A3B8;
    margin-top: 2px;
}

.export-divider {
    height: 1px;
    background: #F1F5F9;
    margin: 4px 8px;
}

/* ════════════════════════════════════════════════════════════════
   CREW DETAILS TABLE
   ════════════════════════════════════════════════════════════════ */
.crew-table-wrap {
    overflow-x: auto;
    margin-top: 4px;
    border-radius: 10px;
}

.crew-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.crew-table th {
    padding: 11px 14px;
    text-align: left;
    font-size: 11px;
    font-weight: 700;
    color: #94A3B8;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    border-bottom: 1.5px solid #F1F5F9;
    white-space: nowrap;
    background: #FAFBFD;
}

.crew-table th:first-child {
    border-radius: 10px 0 0 0;
}

.crew-table th:last-child {
    border-radius: 0 10px 0 0;
}

.crew-table td {
    padding: 13px 14px;
    border-bottom: 1px solid #F8F9FC;
    color: #0F172A;
    vertical-align: middle;
    transition: background 0.1s;
}

.crew-table tr:last-child td {
    border-bottom: none;
}

.crew-table tbody tr:hover td {
    background: #F8F9FC;
}

.crew-name-cell {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 600;
}

.crew-avatar {
    width: 32px;
    height: 32px;
    border-radius: 9px;
    background: linear-gradient(135deg, #EEF2FF 0%, #E0E7FF 100%);
    color: #4F46E5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    flex-shrink: 0;
    border: 1.5px solid #C7D2FE;
}

.crew-td-num {
    text-align: left;
    font-variant-numeric: tabular-nums;
    font-weight: 500;
}

.crew-td-muted {
    color: #94A3B8;
}

.crew-change-badge {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    padding: 3px 9px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
}

.crew-change-badge.pos {
    background: #F0FDF4;
    color: #15803D;
    border: 1px solid #BBF7D0;
}

.crew-change-badge.neg {
    background: #FFF1F2;
    color: #BE123C;
    border: 1px solid #FECDD3;
}

.crew-change-badge.neutral {
    background: #F8FAFC;
    color: #94A3B8;
    border: 1px solid #E2E8F0;
}

/* ════════════════════════════════════════════════════════════════
   PRINT STYLES
   ════════════════════════════════════════════════════════════════ */
@media print {
    body>*:not(#root) {
        display: none !important;
    }

    .analytics-header-actions,
    .analytics-period-bar,
    .analytics-custom-range,
    .analytics-tabs-bar,
    .analytics-refresh-btn,
    .export-wrapper {
        display: none !important;
    }

    .analytics-root {
        background: #fff !important;
        padding: 0 !important;
    }

    .sc-card,
    .chart-card {
        box-shadow: none !important;
        border: 1px solid #E8EAF0 !important;
    }

    .analytics-tab-content>* {
        display: block !important;
    }

    .sc-section,
    .charts-section {
        page-break-inside: avoid;
    }

    .charts-row {
        display: block !important;
    }

    .chart-card {
        margin-bottom: 16px;
    }

    .analytics-header {
        margin-bottom: 16px;
    }

    .analytics-title {
        font-size: 18px !important;
    }

    .crew-table-wrap {
        overflow: visible !important;
    }

    .crew-table {
        width: 100% !important;
        table-layout: fixed;
        page-break-inside: auto;
    }

    .crew-table tr {
        page-break-inside: avoid;
        break-inside: avoid;
    }

    .crew-table th,
    .crew-table td {
        word-break: break-word;
        overflow-wrap: break-word;
        font-size: 11px !important;
    }

    .crew-name-cell {
        flex-wrap: wrap;
    }

    .crew-avatar {
        display: none !important;
    }
}

/* ════════════════════════════════════════════════════════════════
   RESPONSIVE
   ════════════════════════════════════════════════════════════════ */
@media (max-width: 640px) {
    .analytics-root {
        padding: 16px;
    }

    .sc-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .analytics-tabs-bar {
        width: 100%;
    }

    .analytics-tab-btn {
        padding: 8px 12px;
        font-size: 12px;
    }

    .analytics-period-bar {
        width: 100%;
    }

    .analytics-title {
        font-size: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Analytics/analytics.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;wEAiBwE;;AAExE,qEAAqE;;AAGrE,qEAAqE;AACrE;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;IAEI;;QAEI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;;qEAEqE;AACrE;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,0DAA0D;IAC1D,cAAc;IACd,mCAAmC;AACvC;;AAEA;;qEAEqE;AACrE;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6DAA6D;IAC7D,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,6CAA6C;AACjD;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;qEAEqE;AACrE;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA,qEAAqE;AACrE;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA,qEAAqE;AACrE;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,aAAa;AACb;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;IACnB,2EAA2E;IAC3E,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,qEAAqE;AACrE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,qEAAqE;AACrE;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;IACzC,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,gDAAgD;AACpD;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;IAC5C,gBAAgB;AACpB;;AAEA,qEAAqE;AACrE;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;qEAEqE;AACrE;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;qEAEqE;AACrE;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;;qEAEqE;AACrE;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;qEAEqE;AACrE;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;;qEAEqE;AACrE;IACI,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,8DAA8D;IAC9D,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,oDAAoD;IACpD,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;qEAEqE;AACrE;IACI,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA,eAAe;AACf;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;;qEAEqE;AACrE;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,2CAA2C;IAC3C,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;;qEAEqE;AACrE;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;IACnB,2EAA2E;IAC3E,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;qEAEqE;AACrE;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,kCAAkC;IAClC,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;IACd,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6DAA6D;IAC7D,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;qEAEqE;AACrE;IACI;QACI,wBAAwB;IAC5B;;IAEA;;;;;;QAMI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;QAC3B,qBAAqB;IACzB;;IAEA;;QAEI,2BAA2B;QAC3B,oCAAoC;IACxC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;QACxB,mBAAmB;IACvB;;IAEA;;QAEI,sBAAsB;QACtB,yBAAyB;QACzB,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;;qEAEqE;AACrE;IACI;QACI,aAAa;IACjB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* ═══════════════════════════════════════════════════════════════════\n   analytics.css  —  Professional Analytics Dashboard\n   Place at:  src/components/analytics/analytics.css\n   ═══════════════════════════════════════════════════════════════════\n\n   Design tokens\n   ─────────────\n   Primary:   #4F46E5  (indigo)\n   Surface:   #FFFFFF\n   BG:        #F8F9FC\n   Border:    #E8EAF0\n   Text-1:    #0F172A  (headings)\n   Text-2:    #475569  (body)\n   Text-3:    #94A3B8  (muted)\n   Green:     #10B981\n   Red:       #EF4444\n   Amber:     #F59E0B\n   ═══════════════════════════════════════════════════════════════════ */\n\n/* ── Google Font import (DM Sans) ──────────────────────────────── */\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');\n\n/* ── Animations ────────────────────────────────────────────────── */\n@keyframes fadeSlideUp {\n    from {\n        opacity: 0;\n        transform: translateY(8px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes skeletonPulse {\n\n    0%,\n    100% {\n        opacity: 1;\n    }\n\n    50% {\n        opacity: 0.4;\n    }\n}\n\n/* ════════════════════════════════════════════════════════════════\n   ROOT\n   ════════════════════════════════════════════════════════════════ */\n.analytics-root {\n    padding: 28px 32px;\n    background: #F8F9FC;\n    min-height: 100vh;\n    font-family: \"DM Sans\", \"Inter\", -apple-system, sans-serif;\n    color: #0F172A;\n    -webkit-font-smoothing: antialiased;\n}\n\n/* ════════════════════════════════════════════════════════════════\n   HEADER\n   ════════════════════════════════════════════════════════════════ */\n.analytics-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n    gap: 16px;\n}\n\n.analytics-header-left {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n}\n\n.analytics-user-avatar {\n    width: 44px;\n    height: 44px;\n    border-radius: 12px;\n    background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n    font-weight: 700;\n    flex-shrink: 0;\n    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n}\n\n.analytics-title {\n    margin: 0;\n    font-size: 22px;\n    font-weight: 700;\n    color: #0F172A;\n    letter-spacing: -0.3px;\n}\n\n.analytics-subtitle {\n    margin: 3px 0 0;\n    font-size: 13px;\n    color: #94A3B8;\n    font-weight: 400;\n}\n\n.analytics-header-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.analytics-refresh-btn {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 16px;\n    border-radius: 8px;\n    border: 1.5px solid #E8EAF0;\n    background: #fff;\n    color: #475569;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.15s;\n    font-family: inherit;\n}\n\n.analytics-refresh-btn:hover {\n    background: #F8F9FC;\n    border-color: #CBD5E1;\n    color: #0F172A;\n}\n\n/* ════════════════════════════════════════════════════════════════\n   PERIOD BAR  (Today / This Week / This Month / This Year / Custom)\n   ════════════════════════════════════════════════════════════════ */\n.analytics-period-bar {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin-bottom: 8px;\n    flex-wrap: wrap;\n    background: #fff;\n    border: 1.5px solid #E8EAF0;\n    padding: 4px;\n    border-radius: 12px;\n    width: fit-content;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n}\n\n.analytics-period-btn {\n    padding: 8px 16px;\n    border-radius: 8px;\n    border: none;\n    background: transparent;\n    color: #64748B;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.15s;\n    white-space: nowrap;\n    font-family: inherit;\n    line-height: 1;\n}\n\n.analytics-period-btn:hover {\n    background: #F1F5F9;\n    color: #0F172A;\n}\n\n.analytics-period-btn.active {\n    background: #4F46E5;\n    color: #fff;\n    font-weight: 600;\n    box-shadow: 0 2px 8px rgba(79, 70, 229, 0.25);\n}\n\n/* ── Period btn group (button + picker chevron together) ───────── */\n.period-btn-group {\n    display: flex;\n    align-items: center;\n    gap: 1px;\n    position: relative;\n}\n\n/* ── Week / Month picker ───────────────────────────────────────── */\n.period-picker {\n    position: relative;\n    display: inline-block;\n}\n\n.period-picker-btn {\n    display: flex;\n    align-items: center;\n    gap: 3px;\n    padding: 8px 7px;\n    border-radius: 7px;\n    border: none;\n    background: transparent;\n    color: #94A3B8;\n    font-size: 10px;\n    cursor: pointer;\n    transition: all 0.15s;\n    font-family: inherit;\n}\n\n.period-picker-btn:hover {\n    background: #F1F5F9;\n    color: #475569;\n}\n\n.period-picker-caret {\n    font-size: 7px;\n}\n\n/* Dropdown */\n.period-picker-dropdown {\n    position: absolute;\n    top: calc(100% + 8px);\n    left: 0;\n    background: #fff;\n    border: 1.5px solid #E8EAF0;\n    border-radius: 14px;\n    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.06);\n    min-width: 220px;\n    z-index: 1000;\n    overflow: hidden;\n    animation: fadeSlideUp 0.15s ease both;\n    padding: 6px;\n}\n\n.period-picker-option {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 10px 14px;\n    border: none;\n    background: transparent;\n    color: #374151;\n    font-size: 13px;\n    text-align: left;\n    cursor: pointer;\n    border-radius: 9px;\n    transition: background 0.1s;\n    font-family: inherit;\n}\n\n.period-picker-option:hover {\n    background: #F8F9FC;\n}\n\n.period-picker-option.selected {\n    background: #EEF2FF;\n    color: #4F46E5;\n    font-weight: 600;\n}\n\n.period-picker-option.selected::after {\n    content: \"✓\";\n    font-size: 12px;\n    color: #4F46E5;\n}\n\n.period-picker-sub {\n    font-size: 11px;\n    color: #94A3B8;\n    font-weight: 400;\n    margin-left: 6px;\n}\n\n/* ── Custom range active label ─────────────────────────────────── */\n.analytics-custom-active-label {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 6px 12px;\n    border-radius: 8px;\n    background: #EEF2FF;\n    border: 1.5px solid #C7D2FE;\n    color: #4F46E5;\n    font-size: 12px;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n/* ── Custom date range picker inputs ───────────────────────────── */\n.analytics-custom-range {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 16px;\n    flex-wrap: wrap;\n    background: #fff;\n    border: 1.5px solid #E8EAF0;\n    border-radius: 12px;\n    padding: 12px 18px;\n    width: fit-content;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n    animation: fadeSlideUp 0.2s ease both;\n}\n\n.analytics-custom-label {\n    font-size: 12px;\n    color: #94A3B8;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.analytics-date-input {\n    border: 1.5px solid #E8EAF0;\n    border-radius: 8px;\n    padding: 7px 12px;\n    font-size: 13px;\n    color: #0F172A;\n    background: #F8F9FC;\n    outline: none;\n    cursor: pointer;\n    font-family: inherit;\n    font-weight: 500;\n    transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.analytics-date-input:focus {\n    border-color: #4F46E5;\n    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n    background: #fff;\n}\n\n/* ── Period context chips ──────────────────────────────────────── */\n.analytics-period-context {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n    margin-top: 10px;\n    margin-bottom: 24px;\n}\n\n.period-context-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 5px 12px;\n    border-radius: 20px;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.period-context-current {\n    background: #F0FDF4;\n    border: 1px solid #BBF7D0;\n    color: #166534;\n}\n\n.period-context-current strong {\n    color: #15803D;\n    font-weight: 700;\n}\n\n.period-context-prev {\n    background: #F5F3FF;\n    border: 1px solid #DDD6FE;\n    color: #5B21B6;\n}\n\n.period-context-prev strong {\n    color: #7C3AED;\n    font-weight: 700;\n}\n\n/* ════════════════════════════════════════════════════════════════\n   ERROR BANNER\n   ════════════════════════════════════════════════════════════════ */\n.analytics-error-banner {\n    background: #FFF1F2;\n    border: 1.5px solid #FECDD3;\n    border-radius: 10px;\n    padding: 14px 18px;\n    margin-bottom: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 13px;\n    color: #BE123C;\n}\n\n.analytics-error-banner button {\n    font-size: 13px;\n    color: #4F46E5;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-weight: 600;\n    font-family: inherit;\n}\n\n/* ════════════════════════════════════════════════════════════════\n   EMPTY STATE\n   ════════════════════════════════════════════════════════════════ */\n.analytics-empty {\n    text-align: center;\n    padding: 80px 24px;\n}\n\n.analytics-empty-icon {\n    font-size: 48px;\n    margin-bottom: 20px;\n    opacity: 0.6;\n}\n\n.analytics-empty-title {\n    font-size: 17px;\n    font-weight: 700;\n    color: #0F172A;\n    margin-bottom: 8px;\n}\n\n.analytics-empty-sub {\n    font-size: 13px;\n    color: #94A3B8;\n}\n\n/* ════════════════════════════════════════════════════════════════\n   SKELETON LOADER\n   ════════════════════════════════════════════════════════════════ */\n.analytics-skeleton-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 16px;\n}\n\n.analytics-skeleton-card {\n    background: #fff;\n    border: 1.5px solid #E8EAF0;\n    border-radius: 14px;\n    padding: 20px;\n    animation: skeletonPulse 1.6s ease-in-out infinite;\n}\n\n.analytics-skeleton-line {\n    background: #F1F5F9;\n    border-radius: 6px;\n    display: block;\n}\n\n/* ════════════════════════════════════════════════════════════════\n   SECTION TITLE\n   ════════════════════════════════════════════════════════════════ */\n.sc-section-title {\n    font-size: 11px;\n    font-weight: 700;\n    color: #94A3B8;\n    margin: 0 0 16px;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n}\n\n/* ════════════════════════════════════════════════════════════════\n   SUMMARY CARDS\n   ════════════════════════════════════════════════════════════════ */\n.sc-section {\n    margin-bottom: 32px;\n    animation: fadeSlideUp 0.3s ease both;\n}\n\n.sc-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));\n    gap: 14px;\n}\n\n.sc-card {\n    background: #fff;\n    border: 1.5px solid #E8EAF0;\n    border-radius: 14px;\n    padding: 18px 20px;\n    transition: box-shadow 0.2s, transform 0.2s, border-color 0.2s;\n    cursor: default;\n    position: relative;\n    overflow: hidden;\n}\n\n.sc-card::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n    background: linear-gradient(90deg, #4F46E5, #7C3AED);\n    opacity: 0;\n    transition: opacity 0.2s;\n}\n\n.sc-card:hover {\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n    transform: translateY(-2px);\n    border-color: #C7D2FE;\n}\n\n.sc-card:hover::before {\n    opacity: 1;\n}\n\n.sc-card-top {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 14px;\n}\n\n.sc-icon {\n    font-size: 18px;\n    line-height: 1;\n}\n\n.sc-label {\n    font-size: 12px;\n    font-weight: 600;\n    color: #64748B;\n    line-height: 1.3;\n    letter-spacing: 0.01em;\n}\n\n.sc-value {\n    font-size: 26px;\n    font-weight: 700;\n    color: #0F172A;\n    line-height: 1;\n    margin-bottom: 8px;\n    letter-spacing: -0.5px;\n}\n\n.sc-change {\n    font-size: 11px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 3px;\n    flex-wrap: wrap;\n}\n\n.sc-change.pos {\n    color: #10B981;\n}\n\n.sc-change.neg {\n    color: #EF4444;\n}\n\n.sc-change.neutral {\n    color: #94A3B8;\n    font-weight: 500;\n}\n\n.sc-change-bracket {\n    font-size: 10px;\n    font-weight: 400;\n    opacity: 0.7;\n    margin-left: 2px;\n}\n\n/* ════════════════════════════════════════════════════════════════\n   CHARTS SECTION\n   ════════════════════════════════════════════════════════════════ */\n.charts-section {\n    margin-bottom: 32px;\n    animation: fadeSlideUp 0.35s ease 0.05s both;\n}\n\n.charts-row {\n    display: grid;\n    grid-template-columns: 3fr 2fr;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n@media (max-width: 767.98px) {\n    .charts-row {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* Chart card */\n.chart-card {\n    background: #fff;\n    border: 1.5px solid #E8EAF0;\n    border-radius: 14px;\n    padding: 20px 22px;\n    position: relative;\n    transition: box-shadow 0.2s;\n}\n\n.chart-card:hover {\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);\n}\n\n.chart-card-wide {\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.chart-card-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 18px;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.chart-card-title {\n    font-size: 14px;\n    font-weight: 700;\n    color: #0F172A;\n    letter-spacing: -0.1px;\n}\n\n.chart-card-sub {\n    font-size: 12px;\n    color: #94A3B8;\n    font-weight: 400;\n}\n\n/* Chart legend */\n.chart-legend {\n    display: flex;\n    gap: 16px;\n    flex-wrap: wrap;\n}\n\n.chart-legend-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    color: #64748B;\n    font-weight: 500;\n}\n\n.chart-legend-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 2px;\n    flex-shrink: 0;\n}\n\n/* Empty chart */\n.chart-empty {\n    height: 140px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #CBD5E1;\n    font-size: 13px;\n    font-weight: 500;\n}\n\n/* Donut center */\n.donut-center-label {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -28%);\n    text-align: center;\n    pointer-events: none;\n}\n\n.donut-center-value {\n    font-size: 24px;\n    font-weight: 700;\n    color: #0F172A;\n    line-height: 1;\n    letter-spacing: -0.5px;\n}\n\n.donut-center-sub {\n    font-size: 11px;\n    color: #94A3B8;\n    margin-top: 3px;\n    font-weight: 500;\n}\n\n/* Donut legend rows */\n.donut-legend {\n    margin-top: 18px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.donut-legend-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 13px;\n}\n\n.donut-legend-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 3px;\n    flex-shrink: 0;\n}\n\n.donut-legend-label {\n    flex: 1;\n    color: #475569;\n    font-weight: 500;\n}\n\n.donut-legend-count {\n    font-weight: 700;\n    color: #0F172A;\n    min-width: 28px;\n    text-align: right;\n}\n\n.donut-legend-pct {\n    color: #94A3B8;\n    font-size: 12px;\n    min-width: 40px;\n    text-align: right;\n}\n\n/* ════════════════════════════════════════════════════════════════\n   DETAIL TABS BAR\n   ════════════════════════════════════════════════════════════════ */\n.analytics-tabs-bar {\n    display: flex;\n    gap: 4px;\n    margin-bottom: 20px;\n    background: #fff;\n    border: 1.5px solid #E8EAF0;\n    border-radius: 12px;\n    padding: 4px;\n    width: fit-content;\n    flex-wrap: wrap;\n    animation: fadeSlideUp 0.35s ease 0.1s both;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n}\n\n.analytics-tab-btn {\n    padding: 9px 20px;\n    border-radius: 9px;\n    border: none;\n    background: transparent;\n    color: #64748B;\n    font-weight: 500;\n    font-size: 13px;\n    cursor: pointer;\n    transition: all 0.15s;\n    font-family: inherit;\n    white-space: nowrap;\n}\n\n.analytics-tab-btn:hover {\n    background: #F8F9FC;\n    color: #0F172A;\n}\n\n.analytics-tab-btn.active {\n    background: #4F46E5;\n    color: #fff;\n    font-weight: 600;\n    box-shadow: 0 2px 8px rgba(79, 70, 229, 0.25);\n}\n\n.analytics-tab-content {\n    animation: fadeSlideUp 0.25s ease both;\n}\n\n/* ════════════════════════════════════════════════════════════════\n   EXPORT BUTTON\n   ════════════════════════════════════════════════════════════════ */\n.export-wrapper {\n    position: relative;\n    display: inline-block;\n}\n\n.export-main-btn {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 16px;\n    border-radius: 8px;\n    border: 1.5px solid #E8EAF0;\n    background: #fff;\n    color: #475569;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.15s;\n    white-space: nowrap;\n    font-family: inherit;\n}\n\n.export-main-btn:hover {\n    background: #F8F9FC;\n    border-color: #CBD5E1;\n    color: #0F172A;\n}\n\n.export-icon {\n    font-size: 13px;\n}\n\n.export-caret {\n    font-size: 8px;\n    color: #94A3B8;\n}\n\n.export-dropdown {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    background: #fff;\n    border: 1.5px solid #E8EAF0;\n    border-radius: 14px;\n    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.06);\n    min-width: 220px;\n    z-index: 999;\n    overflow: hidden;\n    animation: fadeSlideUp 0.15s ease both;\n    padding: 6px;\n}\n\n.export-option {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n    padding: 11px 14px;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    text-align: left;\n    transition: background 0.12s;\n    border-radius: 9px;\n    font-family: inherit;\n}\n\n.export-option:hover {\n    background: #F8F9FC;\n}\n\n.export-option-icon {\n    font-size: 20px;\n    flex-shrink: 0;\n}\n\n.export-option-label {\n    font-size: 13px;\n    font-weight: 600;\n    color: #0F172A;\n}\n\n.export-option-sub {\n    font-size: 11px;\n    color: #94A3B8;\n    margin-top: 2px;\n}\n\n.export-divider {\n    height: 1px;\n    background: #F1F5F9;\n    margin: 4px 8px;\n}\n\n/* ════════════════════════════════════════════════════════════════\n   CREW DETAILS TABLE\n   ════════════════════════════════════════════════════════════════ */\n.crew-table-wrap {\n    overflow-x: auto;\n    margin-top: 4px;\n    border-radius: 10px;\n}\n\n.crew-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n}\n\n.crew-table th {\n    padding: 11px 14px;\n    text-align: left;\n    font-size: 11px;\n    font-weight: 700;\n    color: #94A3B8;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    border-bottom: 1.5px solid #F1F5F9;\n    white-space: nowrap;\n    background: #FAFBFD;\n}\n\n.crew-table th:first-child {\n    border-radius: 10px 0 0 0;\n}\n\n.crew-table th:last-child {\n    border-radius: 0 10px 0 0;\n}\n\n.crew-table td {\n    padding: 13px 14px;\n    border-bottom: 1px solid #F8F9FC;\n    color: #0F172A;\n    vertical-align: middle;\n    transition: background 0.1s;\n}\n\n.crew-table tr:last-child td {\n    border-bottom: none;\n}\n\n.crew-table tbody tr:hover td {\n    background: #F8F9FC;\n}\n\n.crew-name-cell {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-weight: 600;\n}\n\n.crew-avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 9px;\n    background: linear-gradient(135deg, #EEF2FF 0%, #E0E7FF 100%);\n    color: #4F46E5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 700;\n    flex-shrink: 0;\n    border: 1.5px solid #C7D2FE;\n}\n\n.crew-td-num {\n    text-align: left;\n    font-variant-numeric: tabular-nums;\n    font-weight: 500;\n}\n\n.crew-td-muted {\n    color: #94A3B8;\n}\n\n.crew-change-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 2px;\n    padding: 3px 9px;\n    border-radius: 20px;\n    font-size: 11px;\n    font-weight: 700;\n}\n\n.crew-change-badge.pos {\n    background: #F0FDF4;\n    color: #15803D;\n    border: 1px solid #BBF7D0;\n}\n\n.crew-change-badge.neg {\n    background: #FFF1F2;\n    color: #BE123C;\n    border: 1px solid #FECDD3;\n}\n\n.crew-change-badge.neutral {\n    background: #F8FAFC;\n    color: #94A3B8;\n    border: 1px solid #E2E8F0;\n}\n\n/* ════════════════════════════════════════════════════════════════\n   PRINT STYLES\n   ════════════════════════════════════════════════════════════════ */\n@media print {\n    body>*:not(#root) {\n        display: none !important;\n    }\n\n    .analytics-header-actions,\n    .analytics-period-bar,\n    .analytics-custom-range,\n    .analytics-tabs-bar,\n    .analytics-refresh-btn,\n    .export-wrapper {\n        display: none !important;\n    }\n\n    .analytics-root {\n        background: #fff !important;\n        padding: 0 !important;\n    }\n\n    .sc-card,\n    .chart-card {\n        box-shadow: none !important;\n        border: 1px solid #E8EAF0 !important;\n    }\n\n    .analytics-tab-content>* {\n        display: block !important;\n    }\n\n    .sc-section,\n    .charts-section {\n        page-break-inside: avoid;\n    }\n\n    .charts-row {\n        display: block !important;\n    }\n\n    .chart-card {\n        margin-bottom: 16px;\n    }\n\n    .analytics-header {\n        margin-bottom: 16px;\n    }\n\n    .analytics-title {\n        font-size: 18px !important;\n    }\n\n    .crew-table-wrap {\n        overflow: visible !important;\n    }\n\n    .crew-table {\n        width: 100% !important;\n        table-layout: fixed;\n        page-break-inside: auto;\n    }\n\n    .crew-table tr {\n        page-break-inside: avoid;\n        break-inside: avoid;\n    }\n\n    .crew-table th,\n    .crew-table td {\n        word-break: break-word;\n        overflow-wrap: break-word;\n        font-size: 11px !important;\n    }\n\n    .crew-name-cell {\n        flex-wrap: wrap;\n    }\n\n    .crew-avatar {\n        display: none !important;\n    }\n}\n\n/* ════════════════════════════════════════════════════════════════\n   RESPONSIVE\n   ════════════════════════════════════════════════════════════════ */\n@media (max-width: 640px) {\n    .analytics-root {\n        padding: 16px;\n    }\n\n    .sc-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .analytics-tabs-bar {\n        width: 100%;\n    }\n\n    .analytics-tab-btn {\n        padding: 8px 12px;\n        font-size: 12px;\n    }\n\n    .analytics-period-bar {\n        width: 100%;\n    }\n\n    .analytics-title {\n        font-size: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
